import { MouseEventHandler, ReactElement, useState } from "react";
import { View, Text } from "react-native";
import { FONT } from "../../value/staticValues";

import { ReactComponent as ContentFileImg } from '../../img/ico-contents-file.svg';
import { ReactComponent as ButtonCloseImg } from '../../img/btn-close.svg';

interface CustomInputFileBtnProps {
    size?: { width?: number; height?: number };
    fontsize?: number;
    text: String;
    disabled?: boolean;
    img: {
        inactive: ReactElement;
        active: ReactElement;
    }
    inputCb: Function;
    accept?: string;
    value?: FileList|null;
};

export function CustomInputFileBtn(props:CustomInputFileBtnProps) {
    const [mouseState, setMouseState] = useState(false);

    function setFileInput(e) {
        props.inputCb(e.target.files);
    }
    function clickRemoveFile(event) {
        props.inputCb(null);
        event.preventDefault();
    }
    return (
        <label>
            <input type={"file"}
                style={{
                    border: "0px",
                    width: "0px",
                    height: "0px",
                    display: "none"
                }}
                multiple={false}
                accept={props.accept ? props.accept : "*"}
                onInput={(e) => { setFileInput(e); }}
            />
            {
                props.value && props.value !== null && props.value.length > 0 ?
                    <div style={{marginLeft: 5, display: "flex", alignItems:"center"}}>
                        <ContentFileImg />
                        <Text style={{
                            marginLeft: 6,
                            maxWidth: 360,
                            overflow: "hidden",
                            fontFamily: FONT.MEDIUM,
                            fontSize: props.fontsize? props.fontsize : 14,
                            color: "#3a3b3f",
                        }} numberOfLines={1}>
                            {props.value[0].name}
                        </Text>
                        <div style={{
                            marginLeft: 5,
                            fontFamily: FONT.MEDIUM,
                            fontSize: props.fontsize? props.fontsize : 12,
                            color: "#0853fb"
                        }}>
                            {
                                (() => {
                                    let itemSizeText = props.value[0].size + " Bytes";
                                    if(props.value[0].size > 1024 * 1024 * 1024) {
                                        itemSizeText = parseFloat((props.value[0].size / (1024 * 1024 * 1024)).toFixed(1)) + " GB";
                                    } else if(props.value[0].size > 1024 * 1024) {
                                        itemSizeText = parseFloat((props.value[0].size / (1024 * 1024)).toFixed(1)) + " MB";
                                    } else if(props.value[0].size > 1024) {
                                        itemSizeText = parseFloat((props.value[0].size / 1024).toFixed(1)) + " KB";
                                    }
                                    return itemSizeText
                                })()
                            }
                        </div>
                        <ButtonCloseImg style={{marginLeft: 8, cursor: "pointer"}} onClick={(e) => {clickRemoveFile(e)}} />
                    </div>
                :
                    <div
                        style={{
                            width: props.size?.width || 70, minWidth: 70,
                            height: props.size?.height || 36, minHeight: 36,
                            display: "flex", justifyContent: "center", alignItems: "center",
                            borderRadius: 10, borderWidth: 1, borderStyle: "solid",
                            borderColor: props.disabled ? "#d4d9db" : mouseState? "#d4d9db" : "rgba(60, 93, 242, 0.5)",
                            backgroundColor: props.disabled ? "#f2f4f7" : mouseState? "#4f5fd8" : "#fff",
                            fontFamily: FONT.MEDIUM,
                            fontSize: props.fontsize? props.fontsize : 12,
                            boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.2)",
                            color: props.disabled ? "#d4d9db" : mouseState? "#fff" : "#3c5df2",
                            cursor: props.disabled ? "initial" : "pointer",
                        }}
                        onMouseOut={() => {
                            setMouseState(false);
                        }}
                        onMouseOver={() => {
                            setMouseState(true);
                        }}
                    >
                        <View style={{ width: 20, height: 20, marginRight: 5}}>
                            {mouseState? 
                                props.img.active
                            :
                                props.img.inactive
                            }
                        </View>
                        {props.text}
                    </div>
            }
        </label>
    )
}
